/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import OthersCommonUI from '@components/UI/Others/OthersCommonUI';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';
import MeetSadhguru from '@components/Sliders/MeetSadhguru';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/othersService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Center Landing Page Data
 */

const SadhguruSchedule = ({ region, language, pageData }) => {
  debugger;
  const pageConfig =
    pageData?.pageConfig != null ? pageData?.pageConfig[0]?.value : '';
  const breadcrumbVisibility =
    pageData?.pageConfig != null
      ? pageData?.pageConfig[0]?.value?.breadcrumb !== 'disable'
      : '';
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
        pageconfig={pageData?.pageConfig}
      >
        {' '}
      </HeadComponent>
      {breadcrumbVisibility && (
        <Breadcrum
          page={pageData.breadcrumbs}
          alsoin={pageData.alsoin}
          url=""
          region={region}
          lang={language}
          pageConfig={pageData?.pageConfig}
        />
      )}

      <Box as="section" className="page-wrap container-article" p="0">
        <OthersCommonUI
          pageBody={pageData.body}
          region={region}
          lang={language}
          pageName={pageConfig?.pageName}
        />
        <Box w="100%">
            {pageData.meet_sadhguru?.results != 0 ? (
              <MeetSadhguru
                meetData={
                  pageData?.meet_sadhguru && pageData?.meet_sadhguru?.results
                }
              />
            ) : (
              ''
            )}
          </Box>
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const scheduleLandingPaths = config.USE_LOCAL_URL
  ? [`/in/en/sadhguru-schedule`]
  : await getLandingPaths('lvl0', '/sadhguru-schedule');
  return {
    paths: scheduleLandingPaths,
    fallback: false,
  };
};
  
export const getStaticProps = async ({
    preview,
    previewData,
    params: { region, language },
    req,
  }) => {
  
    const headerTopMenuData = await fetchHeaderTopMenuData(
      getLocale(region, language),
      'isotopmenu'
    );
  
    const headerMenuData = await fetchHeaderMenuData(
      getLocale(region, language),
      'iso_non_regional_menu'
    );
    const footerData = await fetchFooterData(
      getLocale(region, language),
      'isofooter'
    );
    const pageData = await fetchDetails(region, language, 'sadhguru-schedule', {
      preview,
      data: previewData,
    });
  
    return {
      props: {
        headerTopMenuData: headerTopMenuData?.data || null,
        headerMenuData: headerMenuData?.data || null,
        region: '',
        language: language,
        footerData: footerData?.data || null,
        pageData: pageData || null,
        isPreview: preview ? true : false
      }
    };
};  

export default SadhguruSchedule;